import { useState } from "react";
import { Sparkles, X } from "lucide-react";

export default function NumberOfSlideSetter({ generateCarousel, onClose }) {
  const [numberOfSlides, setNumberOfSlides] = useState(8);

  const minSlides = 3;
  const maxSlides = 50;

  return (
    <div 
        className="fixed inset-0 z-40 grid w-screen h-screen p-4 place-items-center bg-gray-700/75 sm:p-6 lg:p-8"
        onClick={(e) => {
          if (e.target === e.currentTarget && onClose) {
            onClose();
          }
        }}
      >
        <div className="relative w-full max-h-[90vh] overflow-y-auto max-w-2xl p-6 space-y-6 mx-auto bg-white shadow-xl rounded-xl">
        <div className="space-y-2">
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-3 flex-1">
              <div className="flex-shrink-0">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="8" fill="#EAECF0"/>
              <path d="M22 10H10M22 22H10M11.3333 16C11.3333 15.3787 11.3333 15.0681 11.4348 14.8231C11.5702 14.4964 11.8297 14.2368 12.1564 14.1015C12.4015 14 12.7121 14 13.3333 14L18.6667 14C19.2879 14 19.5986 14 19.8436 14.1015C20.1703 14.2368 20.4298 14.4964 20.5652 14.8231C20.6667 15.0681 20.6667 15.3787 20.6667 16C20.6667 16.6213 20.6667 16.9319 20.5652 17.1769C20.4298 17.5036 20.1703 17.7632 19.8436 17.8985C19.5985 18 19.2879 18 18.6667 18L13.3333 18C12.7121 18 12.4015 18 12.1564 17.8985C11.8297 17.7632 11.5702 17.5036 11.4348 17.1769C11.3333 16.9319 11.3333 16.6213 11.3333 16Z" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              </div>
            </div>
            {onClose && (
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0 ml-4"
                aria-label="Close"
              >
                <X className="w-6 h-6" />
              </button>
            )}
          </div>

          <h2 className="text-base font-semibold text-gray-900">
            Choose how many slides you'd like in your carousel
          </h2>
        </div>

        {/* Number of Slides Section */}
        <div className="space-y-1">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-gray-700">Number of Slides</span>
            <span className="text-lg font-semibold text-blue-500">{numberOfSlides}</span>
          </div>

          {/* Range Slider */}
          <div className="space-y-1">
            <input
              type="range"
              min={minSlides}
              max={maxSlides}
              value={numberOfSlides}
              onChange={(e) => setNumberOfSlides(parseInt(e.target.value))}
              className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-blue-500 [&::-webkit-slider-thumb]:cursor-pointer [&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:border-white [&::-webkit-slider-thumb]:shadow-sm [&::-webkit-slider-thumb:hover]:bg-blue-500 [&::-moz-range-thumb]:w-5 [&::-moz-range-thumb]:h-5 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-blue-500 [&::-moz-range-thumb]:cursor-pointer [&::-moz-range-thumb]:border-2 [&::-moz-range-thumb]:border-white [&::-moz-range-thumb]:shadow-sm [&::-moz-range-thumb:hover]:bg-blue-500"
              style={{
              background: `linear-gradient(to right, rgba(12, 165, 236, 1) 0%, rgba(12, 165, 236, 1) ${((numberOfSlides - minSlides) / (maxSlides - minSlides)) * 100}%, rgb(229, 231, 235) ${((numberOfSlides - minSlides) / (maxSlides - minSlides)) * 100}%, rgb(229, 231, 235) 100%)`
              }}
            />
            <div className="flex justify-between text-xs text-gray-500">
              <span>{minSlides} Slides</span>
              <span>{maxSlides} Slides</span>
            </div>
          </div>
        </div>

        {/* Pro-Tip Section */}
        <div className="space-y-1">
            <p className="text-xs text-gray-700">
            💡Pro-Tip: 6-8 slides works best for most Linkedin carousels.
            </p>
            <p className="text-xs text-gray-700">
            ✨ Your content will be intelligently distributed across the selected number of slides.
            </p>
        </div>
        <div className="w-full h-px bg-gray-200" />
        {/* Generate Button */}
        <div className="flex justify-end">
          <button
            type="button"
            onClick={() => generateCarousel(numberOfSlides)}
            className="inline-flex items-center justify-center gap-2 transition-all duration-150 rounded-full px-4 py-2.5 text-sm font-semibold hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 bg-blue-500 text-white"
          >
            <Sparkles className="w-4 h-4" />
            Generate Carousel
          </button>
        </div>
      </div>
    </div>
  );
}
